import { useRef as S, useEffect as c } from "react";
import { getInitialFocusedDate as x } from "./index.es2484.js";
const M = ({
  position: r,
  calendar: n,
  focusedDateLeft: l,
  focusedDateRight: u,
  setFocusedDateLeft: f,
  setFocusedDateRight: m,
  selectedRangeData: y,
  TODAY: s,
  leftPanelDayRefs: w,
  rightPanelDayRefs: v
}) => {
  const F = S(/* @__PURE__ */ new Map());
  return c(() => {
    if (!(r === "left" ? l : u)) {
      const t = x(
        y.value,
        r,
        n.days,
        s
      );
      t && (r === "left" ? f(t) : m(t));
    }
  }, [
    n.days,
    r,
    l,
    u,
    y.value,
    s,
    f,
    m
  ]), c(() => {
    const e = r === "left" ? w : v;
    e.current.length !== n.days.length && (e.current = new Array(n.days.length).fill(null));
  }, [n.days, r, w, v]), c(() => {
    const e = r === "left" ? l : u;
    if (e) {
      const t = e.toISOString(), I = F.current.get(t);
      I && I.focus();
    }
  }, [l, u, r]), {
    dateRefs: F
  };
};
export {
  M as useDatePanelView
};
//# sourceMappingURL=index.es5867.js.map
